import { NEWS_CATEGORY, NEWS_DATASET, NEWS_SECTOR } from "./types";

export const datasetDropdownConfig: Record<
	Exclude<NEWS_DATASET, NEWS_DATASET.AI_ANALYSIS>,
	{ label: string; value: NEWS_DATASET }
> = {
	[NEWS_DATASET.NEWS]: {
		label: "News",
		value: NEWS_DATASET.NEWS,
	},
	[NEWS_DATASET.EVENTS]: {
		label: "Top",
		value: NEWS_DATASET.EVENTS,
	},
	[NEWS_DATASET.BRIEF]: {
		label: "Brief",
		value: NEWS_DATASET.BRIEF,
	},
};

export const categoryDropdownConfig: Record<
	| NEWS_DATASET.AI_ANALYSIS
	| Exclude<NEWS_CATEGORY, NEWS_CATEGORY.PERSONNEL | NEWS_CATEGORY.EXECUTIVE>,
	{ label: string; value: NEWS_CATEGORY | NEWS_DATASET }
> = {
	[NEWS_CATEGORY.INVESTOR_SENTIMENT]: {
		label: "Sentiment",
		value: NEWS_CATEGORY.INVESTOR_SENTIMENT,
	},
	[NEWS_CATEGORY.LEGAL]: {
		label: "Legal",
		value: NEWS_CATEGORY.LEGAL,
	},
	[NEWS_CATEGORY.FINANCIALS]: {
		label: "Financials",
		value: NEWS_CATEGORY.FINANCIALS,
	},
	[NEWS_CATEGORY.DIVIDEND]: {
		label: "Dividend",
		value: NEWS_CATEGORY.DIVIDEND,
	},
	[NEWS_CATEGORY.EXCEPTIONAL_INCIDENT]: {
		label: "Exceptional Incident",
		value: NEWS_CATEGORY.EXCEPTIONAL_INCIDENT,
	},
	[NEWS_CATEGORY.TRANSCRIPTS]: {
		label: "Transcripts",
		value: NEWS_CATEGORY.TRANSCRIPTS,
	},
	[NEWS_CATEGORY.INSIDER_TRADING]: {
		label: "Insider Transactions",
		value: NEWS_CATEGORY.INSIDER_TRADING,
	},
	[NEWS_CATEGORY.MERGERS_AND_ACQUISITIONS]: {
		label: "Mergers & Acquisitions",
		value: NEWS_CATEGORY.MERGERS_AND_ACQUISITIONS,
	},
	[NEWS_CATEGORY.GENERAL_NEWS]: {
		label: "General",
		value: NEWS_CATEGORY.GENERAL_NEWS,
	},
	[NEWS_CATEGORY.PARTNERSHIPS]: {
		label: "Partnerships",
		value: NEWS_CATEGORY.PARTNERSHIPS,
	},
	[NEWS_CATEGORY.PRODUCT_UPDATE]: {
		label: "Product Updates",
		value: NEWS_CATEGORY.PRODUCT_UPDATE,
	},
	[NEWS_CATEGORY.EARNINGS]: {
		label: "Earnings",
		value: NEWS_CATEGORY.EARNINGS,
	},
	[NEWS_CATEGORY.ANALYST_REVIEW]: {
		label: "Analyst Views",
		value: NEWS_CATEGORY.ANALYST_REVIEW,
	},
	[NEWS_CATEGORY.MANAGEMENT]: {
		label: "Management",
		value: NEWS_CATEGORY.MANAGEMENT,
	},
	[NEWS_CATEGORY.TRADING]: {
		label: "Trading",
		value: NEWS_CATEGORY.TRADING,
	},
	[NEWS_DATASET.AI_ANALYSIS]: {
		label: "AI Analysis",
		value: NEWS_DATASET.AI_ANALYSIS,
	},
	[NEWS_CATEGORY.OTHER]: {
		label: "Other",
		value: NEWS_CATEGORY.OTHER,
	},
};

export const sectorDropdownConfig: Record<
	NEWS_SECTOR,
	{ label: string; value: NEWS_SECTOR }
> = {
	[NEWS_SECTOR.BASIC_MATERIALS]: {
		label: "Basic Materials",
		value: NEWS_SECTOR.BASIC_MATERIALS,
	},
	[NEWS_SECTOR.COMMUNICATION_SERVICES]: {
		label: "Communication Services",
		value: NEWS_SECTOR.COMMUNICATION_SERVICES,
	},
	[NEWS_SECTOR.CONSUMER_CYCLICAL]: {
		label: "Consumer Cyclical",
		value: NEWS_SECTOR.CONSUMER_CYCLICAL,
	},
	[NEWS_SECTOR.CONSUMER_DEFENSIVE]: {
		label: "Consumer Defensive",
		value: NEWS_SECTOR.CONSUMER_DEFENSIVE,
	},
	[NEWS_SECTOR.ENERGY]: {
		label: "Energy",
		value: NEWS_SECTOR.ENERGY,
	},
	[NEWS_SECTOR.FINANCIAL]: {
		label: "Financial",
		value: NEWS_SECTOR.FINANCIAL,
	},
	[NEWS_SECTOR.FINANCIAL_SERVICES]: {
		label: "Financial Services",
		value: NEWS_SECTOR.FINANCIAL_SERVICES,
	},
	[NEWS_SECTOR.HEALTHCARE]: {
		label: "Healthcare",
		value: NEWS_SECTOR.HEALTHCARE,
	},
	[NEWS_SECTOR.INDUSTRIAL]: {
		label: "Industrial",
		value: NEWS_SECTOR.INDUSTRIAL,
	},
	[NEWS_SECTOR.INDUSTRIALS]: {
		label: "Industrials",
		value: NEWS_SECTOR.INDUSTRIALS,
	},
	[NEWS_SECTOR.REAL_ESTATE]: {
		label: "Real Estate",
		value: NEWS_SECTOR.REAL_ESTATE,
	},
	[NEWS_SECTOR.TECHNOLOGY]: {
		label: "Technology",
		value: NEWS_SECTOR.TECHNOLOGY,
	},
	[NEWS_SECTOR.UTILITIES]: {
		label: "Utilities",
		value: NEWS_SECTOR.UTILITIES,
	},
};
